/**
 * Vue i18n localisation
 **/
import VueI18n from 'vue-i18n';

export const plugin = {
    name: 'i18n',

    pluginProperties: {
        i18n: null
    },

    install (Vue, options) {
        Vue.use(VueI18n);

        const { store } = options;
        const locale = store.getters['ux/getLocale']; // getDefaultLocale();

        // init i18n with locale and messages
        this.pluginProperties.i18n = new VueI18n({
            locale,
            fallbackLocale: 'en',
            messages: {
                // bundle English translations
                en: require('@/translations/locale-en.json')
            }
        });

        // loads messages and listens to locale change in AppLocalisationMixin
    }
};

export default plugin;
